/**
 * Users Service
 * API operations for user preferences, profile, and avatar
 */
import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type { UpdateUserPreferencesRequest } from '@/types/api/requests';
import type { UpdateUserPreferencesResponse } from '@/types/api/responses';

export const usersService = {
  /**
   * Update user preferences (language/theme)
   */
  updatePreferences: (data: UpdateUserPreferencesRequest) =>
    apiClient.patch<UpdateUserPreferencesResponse>(
      API_ENDPOINTS.USERS.PREFERENCES,
      data
    ),

  /**
   * Update profile (display name, avatar URL)
   */
  updateProfile: (data: { displayName?: string; avatarUrl?: string }) =>
    apiClient.patch<{ displayName: string; avatarUrl: string | null }>(
      API_ENDPOINTS.USERS.PROFILE,
      data
    ),

  /**
   * Upload avatar file
   */
  uploadAvatar: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post<{ avatarUrl: string }>(
      API_ENDPOINTS.USERS.AVATAR,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },

  /**
   * Delete user avatar
   */
  deleteAvatar: () => apiClient.delete(API_ENDPOINTS.USERS.AVATAR),

  /**
   * Request account deletion
   */
  deleteAccount: () => apiClient.delete(API_ENDPOINTS.USERS.DELETE_ACCOUNT),
};
